export default __webpack_public_path__ + "static/media/066-job-interview.674d9f0e.svg";